module.exports = __webpack_public_path__ + "img/emptyBox.9bd784a8.svg";